import React from "react";
import { Typography, Box } from "@material-ui/core";
import { Address } from "../../../api/services";

const AddressLine: React.FC<{ line: string | null | undefined }> = ({ line }) =>
  line ? <Typography variant="subtitle1">{line}</Typography> : null;

export const AddressFields: React.FC<Address> = ({
  address1,
  address2,
  address3,
  address4,
  address5,
  postcode,
}) => (
  <>
    <Typography variant="caption">Billing Address</Typography>
    <Box clone fontStyle="normal">
      <address>
        <AddressLine line={address1} />
        <AddressLine line={address2} />
        <AddressLine line={address3} />
        <AddressLine line={address4} />
        <AddressLine line={address5} />
        <AddressLine line={postcode} />
      </address>
    </Box>
  </>
);
